export const useBannerPosition = (blockData, horizontal) => {
  const ifBlockData = blockData === undefined ? [] : blockData.items;
  const dataBanner = ifBlockData.filter(banner => {
    if (horizontal) {
      if (banner.position_horizontal === true) {
        return true;
      }
    } else {
      if (banner.position_horizontal === false) {
        return true;
      }
    }
  });

  // function for generate random number of banner
  function randomInteger(min, max) {
    // random number min to (max)
    let rand = min + Math.random() * (max - min);
    return Math.floor(rand);
  }

  const numberBannerFirst = randomInteger(0, dataBanner.length);
  const numberBannerSecond = randomInteger(0, dataBanner.length);

  return { dataBanner, numberBannerFirst, numberBannerSecond };
};
